import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import Toggle from 'react-toggle';
import { PulseLoader } from 'react-spinners';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';

import { editCategory, categories } from '../../../../../queries';

import {
  Padding,
  Content,
  Footer,
  ToggleContainer,
  Button,
  DeleteButton,
} from './styles';
import { Label, Input } from '../../../../../assets/styles';


class EditCategoryModal extends Component {
  state = {
    loading: false,
    categoryId: '',
    categoryName: '',
    visible: true,
    categoryNameError: false,
    categoryNameFocus: false,
  }

  openEditCategoryModal = (id, category, visible) => {
    this.setState({
      categoryId: id,
      categoryName: category,
      visible,
      categoryNameError: false,
      categoryNameFocus: false,
    });
  }

  handleSubmit = async () => {
    await this.validateInputs();

    const { categoryNameError } = this.state;

    if (!categoryNameError) {
      this.setState({ loading: true });

      const { categoryId, categoryName, visible } = this.state;

      this.props
        .editCategory({
          variables: {
            storeId: this.props.storeId,
            categoryId,
            name: categoryName,
            visible,
          },
          refetchQueries: [{ query: categories, variables: { storeId: this.props.storeId } }],
        })
        .then(async (res) => {
          this.setState({ loading: false });
          this.props.alert.success('Categoria editada com sucesso');
          this.props.handleCategoriesList(res.data.editCategoryPortal);
          this.props.close();
        });
    }
  }

  deleteCategory = () => {
    this.props.deleteCategory(this.state.categoryId);
  }

  validateInputs = async () => {
    this.setState({ categoryNameError: false });

    const { categoryName } = this.state;

    const categoryNameReg = /[0-9]/g;
    if (categoryName.length === 0 || categoryNameReg.test(categoryName)) {
      this.setState({ categoryNameError: true });
    }
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleToggleButton = () => {
    this.setState(state => ({ visible: !state.visible }));
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      loading,
      categoryName,
      visible,
      categoryNameError,
      categoryNameFocus,
    } = this.state;

    const { open, close } = this.props;

    return (
      <Modal
        open={open}
        onClose={close}
        center
        ref={(ref) => { this.categoryModal = ref; }}
        styles={{
          modal: { width: '460px' },
        }}
      >
        <Content>
          <Padding>
            <h2>Editar categoria</h2>
            <Label>
              <p className="fieldName">
                {'Nome da categoria'}
              </p>
              <Input
                type="text"
                name="categoryName"
                value={categoryName}
                error={categoryNameError}
                onFocusInput={categoryNameFocus}
                onChange={this.handleInputChange}
                onFocus={() => this.onFocus('categoryNameFocus')}
                onBlur={() => this.onBlur('categoryNameFocus')}
              />
            </Label>
          </Padding>
          <Footer>
            <ToggleContainer>
              <Toggle
                defaultChecked={!visible}
                icons={false}
                onChange={this.handleToggleButton}
              />
              <span>Desativar categoria</span>
            </ToggleContainer>
            <p>
              {'Se o botão estiver habilitado esta categoria não aparecerá na lista de categorias da sua loja no aplicativo Reforma Fácil.'}
            </p>
          </Footer>
          <Padding>
            <Button type="submit" disabled={loading} onClick={this.handleSubmit}>
              {!loading ? (
                'Salvar'
              ) : (
                <PulseLoader
                  sizeUnit="px"
                  size={7}
                  color="#FFFFFF"
                  loading={loading}
                />
              )}
            </Button>
            <DeleteButton type="submit" delete onClick={this.deleteCategory}>Excluir</DeleteButton>
          </Padding>
        </Content>
      </Modal>
    );
  }
}

export default compose(
  withAlert(),
  graphql(editCategory, { name: 'editCategory', withRef: true }),
)(EditCategoryModal);
